module.exports = __webpack_public_path__ + "static/img/pars1.c6500169.png";